import {createGrid} from "../../helpers/grids/grids";
import {createRowPickerColumnDef} from "../../helpers/grids/custom-column-types/row-selection/row-selection";
import {ModalV3} from "../../helpers/modals/ClassBased/ModalV3";
import JSONFormatter from "json-formatter-js";
import {loading, stopLoading} from "../../helpers/loading";
import handleAjaxError from "../../helpers/handleAjaxError";

function initGridsExamples() {
	createGrid(
		document.querySelector('.basic-grid'),
		{
			columnDefs: [
				{
					field: 'email',
					sortable: true,
				},
				{
					field: 'created_at',
					sortable: true,
				}
			],
		},
		window['routes/development.grids.examples/basic-grid'],
	)

	createGrid(
		document.querySelector('.basic-grid-no-pagination'),
		{
			columnDefs: [
				{
					field: 'email',
					sortable: true,
				},
				{
					field: 'created_at',
					sortable: true,
				}
			],
			pagination: false,
		},
		window['routes/development.grids.examples/basic-grid'],
	)

	const selectionExampleGrid = createGrid(
		document.querySelector('.grid-with-selection'),
		{
			columnDefs: [
				createRowPickerColumnDef(
					'id',
				),
				{
					field: 'id',
					sortable: true,
				},
				{
					field: 'name',
					sortable: true,
				},
				{
					field: 'email',
					sortable: true,
				},
			],
		},
		null,
	)

	const displayGridSelectionButton = document.querySelector('.display-selection')
	if (displayGridSelectionButton) {
		displayGridSelectionButton.addEventListener('click', () => {
			displayGridSelection();
		})
	}

	const sendSelectionToServerButton = document.querySelector('.send-selection-to-server');
	if (sendSelectionToServerButton) {
		sendSelectionToServerButton.addEventListener('click', () => {
			sendSelectionToServer(sendSelectionToServerButton.dataset.route);
		})
	}

	const clearSelectionButton = document.querySelector('.clear-selection');
	if (clearSelectionButton) {
		clearSelectionButton.addEventListener('click', () => {
			clearGridSelection();
		})
	}

	/** Methods */

	function displayGridSelection() {
		const selection = selectionExampleGrid._getCustomGridSelection();

		const tempModal = (new ModalV3({
			init(modal) {
				modal.modalContainer.querySelector('.modal-title').textContent = 'Selection';
				modal.modalContainer.querySelector('.modal-body').innerHTML = '<div class="selection-display"></div>';

				const formatter = new JSONFormatter(selection);
				modal.modalContainer.querySelector('.selection-display').appendChild(formatter.render());
				formatter.openAtDepth(3);
			}
		}));

		// Manually call init becase we didn't pass any modal html
		tempModal.init();
		tempModal.display(true)
	}

	function sendSelectionToServer(route) {
		const selection = selectionExampleGrid._getCustomGridSelection();

		loading();

		axios.post(route, {gridSelection: selection})
			.then(response => {
				const tempModal = (new ModalV3({
					init(modal) {
						modal.modalContainer.querySelector('.modal-title').textContent = 'Server Response';
						modal.modalContainer.querySelector('.modal-body').innerHTML = '<div class="selection-display"></div>';

						const formatter = new JSONFormatter(response.data);
						modal.modalContainer.querySelector('.selection-display').appendChild(formatter.render());
						formatter.openAtDepth(3);
					}
				}));

				// Manually call init because we didn't pass any modal html
				tempModal.init();
				tempModal.display(true);
			})
			.catch(handleAjaxError)
			.finally(stopLoading);
	}

	function clearGridSelection() {
		selectionExampleGrid._clearCustomGridSelection();
	}
}

export {initGridsExamples}
